import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconAvatar = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M30.656 1.92c-3.776.391-7 1.947-9.573 4.621a14.5 14.5 0 0 0-2.654 3.795 14.9 14.9 0 0 0-1.377 4.256c-.14.819-.196 3.162-.096 4.036a15.2 15.2 0 0 0 4.36 9.072c2.312 2.306 5.227 3.771 8.508 4.28 1.028.158 3.324.158 4.352 0a15 15 0 0 0 4.512-1.422 15.12 15.12 0 0 0 8.317-11.633c.115-.876.13-2.704.031-3.616a15.07 15.07 0 0 0-4.119-8.768c-2.395-2.489-5.399-4.029-8.834-4.53-.796-.116-2.698-.166-3.427-.09m.416 4.005c-.106.016-.422.058-.704.096-3.122.414-6.125 2.393-7.83 5.159-1.556 2.526-2.034 5.69-1.295 8.578.78 3.046 2.863 5.664 5.637 7.082 1.713.876 3.263 1.256 5.12 1.256 4.672 0 8.808-2.89 10.43-7.288 1.288-3.497.681-7.55-1.577-10.524-.44-.578-1.384-1.534-1.976-1.998a11.1 11.1 0 0 0-5.085-2.248c-.536-.09-2.346-.166-2.72-.113m-.704 27.873c-6.398.365-12.647 3.21-17.162 7.813-4.724 4.816-7.513 11.396-7.537 17.781-.005 1.303-.004 1.314.166 1.636.365.692 1.003 1.078 1.781 1.078.737 0 1.345-.34 1.736-.968.214-.345.253-.578.313-1.886.108-2.366.407-4.015 1.117-6.164.675-2.041 1.47-3.664 2.665-5.44A22.4 22.4 0 0 1 32 37.76c2.468 0 4.753.379 7.155 1.187a22.29 22.29 0 0 1 14.063 14.141c.71 2.15 1.01 3.798 1.117 6.164.073 1.596.128 1.789.652 2.297.407.395.813.557 1.397.557.778 0 1.416-.386 1.781-1.078.17-.322.17-.333.166-1.636-.02-5.43-2.073-11.116-5.65-15.648-3.97-5.029-9.803-8.504-16.105-9.597-1.241-.215-1.81-.28-3.104-.353-1.248-.072-1.794-.07-3.104.004" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconAvatar.displayName = 'IconAvatar';